import { call, takeLatest, put } from 'redux-saga/effects';
import { post, get } from '../../helpers/server';

function* getTradeResult(action) {
    try {
        const resp = yield call(post, "/trade/tradeResult", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_trade_result_success", tradeResult: resp.tr, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_trade_result_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_trade_result_fail", status: 0 });
    }
}

function* getTradeResultSearch(action) {
    try {
        const resp = yield call(post, "/trade/tradeResultSearch", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_get_trade_result_search_success", tradeResult: resp.tr });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_trade_result_search_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_trade_result_search_fail", status: 0 });
    }
}

function* getGeneralStrategyResult(action) {
    try {
        const resp = yield call(post, "/trade/generalStrategy", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_general_strategy_result_success", items: resp.items, tradeDetails: resp.td });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_general_strategy_result_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_general_strategy_result_fail", status: 0 });
    }
}

function* getGeneralStrategyResultSearch(action) {
    try {
        const resp = yield call(post, "/trade/generalStrategy", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_general_strategy_result_search_success", tradeDetails: resp.td });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_general_strategy_result_search_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_general_strategy_result_search_fail", status: 0 });
    }
}

function* removeDeployStrategy(action) {
    try {
        const resp = yield call(post, "/trade/remove", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_remove_trade_success", tradeResult: resp.tr, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_remove_trade_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_remove_trade_fail", status: 0 });
    }
}

function* getBasePosition(action) {
    try {
        const resp = yield call(post, "/trade/getBasePosition", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_base_position_success", bp: resp.bp, share: resp.share });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_base_position_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_base_position_fail", status: 0 });
    }
}

function* Effect() {
    yield takeLatest('action_get_trade_result', getTradeResult);

    yield takeLatest('action_get_general_strategy_result', getGeneralStrategyResult);
    yield takeLatest('action_get_general_strategy_result_search', getGeneralStrategyResultSearch);

    yield takeLatest('action_get_trade_result_search', getTradeResultSearch);

    yield takeLatest('action_remove_trade', removeDeployStrategy);

    yield takeLatest('action_get_base_position', getBasePosition);
}

export default Effect;